import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { GenderType } from 'src/app/core/enums/enums';
import { DOCSADoc } from 'src/app/core/models/docsa.model';
import { PnrInfo } from 'src/app/core/models/itinerary.model';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';
import { SettingsService } from 'src/app/settings/services/settings.service';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

@Component({
  selector: 'app-passenger-docsa',
  templateUrl: './passenger-docsa.component.html',
  styleUrls: ['./passenger-docsa.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PassengerDocsaComponent implements OnInit {
  @Input() doc: DOCSADoc;
  @Input() submitted = false;
  @Input() names: string;
  @Input() id: string;

  @Output() docsa = new EventEmitter<DOCSADoc>();

  pnrInfo$: Observable<PnrInfo>;
  isAirline$: Observable<boolean>;

  form: FormGroup;
  expiredDate = new Date();
  birthday = new Date();
  maxDate = new Date();
  minDate = new Date(new Date().getFullYear() - 150, 0, 0);
  firstValueGender = '';
  isDocsRequired: boolean = false;
  GENDER_VALUES = [
    { code: GenderType.Female, name: 'genre-female' },
    { code: GenderType.Male, name: 'genre-male' }
  ];

  constructor(
    private fb: FormBuilder,
    private itineraryService: ItineraryService,
    private settingsService: SettingsService
  ) {}

  ngOnInit() {
    this.isAirline$ = this.settingsService.getClientIsAirline();
    this.pnrInfo$ = this.itineraryService.getPnrInfo().pipe(take(1));
    this.itineraryService
      .getPnrInfo()
      .pipe(take(1))
      .subscribe((pnr) => {
        this.isDocsRequired = pnr?.isDocsRequired;
      });

    if (this.doc) {
      if (this.doc.pasengerDateOfBirth) {
        this.birthday = new Date(this.doc.pasengerDateOfBirth);
      }
      if (this.doc.expirationDate) {
        this.expiredDate = new Date(this.doc.expirationDate);
      }
      if (this.doc.gender) {
        this.firstValueGender = this.doc.gender;
      }
    } else {
      this.birthday = null;
      this.expiredDate = new Date();
      this.firstValueGender = '';
    }
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      passport: [
        !!this.doc ? this.doc.passportHolderIndicator : '',
        !this.isDocsRequired && Validators.required
      ],
      gender: [this.firstValueGender, Validators.required]
    });
  }

  onValueChange() {
    if (this.isValid()) {
      this.docsa.emit(this.buildDOCSA());
    }
  }

  buildDOCSA(): DOCSADoc {
    return {
      pasengerDateOfBirth: this.birthday.toISOString(),
      expirationDate: this.expiredDate.toISOString(),
      gender: this.form.controls.gender.value,
      passportHolderIndicator: this.form.controls.passport.value,
      email: '',
      phoneNumber: ''
    };
  }

  isValid() {
    return (
      !!this.birthday &&
      (this.isDocsRequired ? true : this.form.controls.passport.value.length) &&
      this.form.controls.gender.value.length
    );
  }
}
